import { useEffect, useState } from "react";
import {
  useParams,
  useNavigate
} from "react-router-dom";

function formatDatePro(date) {

  if (!date) return "-";

  const d = new Date(date);

  const jours = String(
    d.getDate()
  ).padStart(2, "0");

  const mois = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc"
  ];

  return `${jours} ${
    mois[d.getMonth()]
  } ${d.getFullYear()}`;
}

function SejourDetail() {

  const { id } = useParams();

  const navigate =
    useNavigate();

  const [data, setData] =
    useState(null);

  const token =
    localStorage.getItem(
      "accessToken"
    );

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    const chargerSejour = async () => {

      try {

        console.log("🔎 Chargement séjour :", id);

        const url =
          `${
            process.env.REACT_APP_API_URL ||
            window.location.origin
          }/api/sejours/${id}`;

        console.log("🌐 URL :", url);

        const res = await fetch(url, {
          headers: {
            Authorization: "Bearer " + token
          }
        });

        console.log(
          "📡 Statut API :",
          res.status
        );

        const text = await res.text();

        console.log(
          "📦 Réponse API :",
          text
        );

        if (!res.ok) {

          throw new Error(
            `Erreur API ${res.status}: ${text}`
          );

        }

        const json = JSON.parse(text);

        console.log(
          "✅ Séjour chargé :",
          json
        );

        setData(json);

      } catch (err) {

        console.error(
          "❌ ERREUR CHARGEMENT SÉJOUR :",
          err
        );

      }

    };

    if (id) {
      chargerSejour();
    }

  }, [id]);

  // =====================
  // LOADING
  // =====================

  if (!data) {

    return (
      <p className="p-4 md:p-6 text-center">
        Chargement...
      </p>
    );

  }

  const total = Number(
    data.total_sejour || 0
  );

  const paye = Number(
    data.total_paye || 0
  );

  const reste = Math.max(
    0,
    total - paye
  );

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 max-w-2xl mx-auto min-h-[100dvh]">

      {/* BACK */}
      <button
        onClick={() =>
          navigate(-1)
        }
        className="bg-gray-200 hover:bg-gray-300 transition px-4 py-2 rounded-xl text-sm mb-4"
      >
        ← Retour
      </button>

      {/* TITLE */}
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 md:mb-6">
        Détail du séjour
      </h2>

      {/* CARD */}
      <div className="bg-white shadow rounded-2xl p-4 md:p-6 space-y-4">

        {/* CLIENT */}
        <div className="border-b pb-3">

          <div className="text-sm text-gray-500">
            Client
          </div>

          <div className="font-semibold text-base md:text-lg break-words">
            {data.nom}{" "}
            {data.prenom}
          </div>

        </div>

        {/* APPART */}
        <div className="border-b pb-3">

          <div className="text-sm text-gray-500">
            Appartement
          </div>

          <div className="font-semibold text-base md:text-lg">
            {data.appartement}
          </div>

        </div>

        {/* DATES */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b pb-3">

          <div>

            <div className="text-sm text-gray-500">
              Début
            </div>

            <div className="font-medium">
              {formatDatePro(
                data.date_debut
              )}
            </div>

          </div>

          <div>

            <div className="text-sm text-gray-500">
              Fin prévue
            </div>

            <div className="font-medium">
              {formatDatePro(
                data.date_fin_prevue
              )}
            </div>

          </div>

        </div>

        {/* FINANCES */}
        <div className="space-y-3">

          <div className="flex justify-between items-center text-sm md:text-base">

            <span className="text-gray-600">
              Total
            </span>

            <span className="font-bold">
              ${total}
            </span>

          </div>

          <div className="flex justify-between items-center text-sm md:text-base">

            <span className="text-gray-600">
              Payé
            </span>

            <span className="font-bold text-green-600">
              ${paye}
            </span>

          </div>

          <div className="flex justify-between items-center text-sm md:text-base">

            <span className="text-gray-600">
              Reste
            </span>

            <span className="font-bold text-red-500">
              ${reste}
            </span>

          </div>

        </div>

      </div>

    </div>
  );
}

export default SejourDetail;